import { resolveApiUrl } from './apiUrls';

const FALLBACK_MEDIA_LOCALE = 'http://localhost:2008/api/media-locale';

const SECTION_API_PATH_BY_CATEGORY = {
  culturel: '/api/culturel',
  economie: '/api/economie',
  sport: '/api/sport',
};

const SECTION_API_ENV_BY_CATEGORY = {
  culturel: process.env.REACT_APP_CULTUREL_API,
  economie: process.env.REACT_APP_ECONOMIE_API,
  sport: process.env.REACT_APP_SPORT_API,
};

const SECTION_MEDIA_ENV_BY_CATEGORY = {
  culturel: process.env.REACT_APP_CULTUREL_MEDIA_API,
  economie: process.env.REACT_APP_ECONOMIE_MEDIA_API,
  sport: process.env.REACT_APP_SPORT_MEDIA_API,
};

const SECTION_MEDIA_ENV_KEY_BY_CATEGORY = {
  culturel: 'CULTUREL_MEDIA_API',
  economie: 'ECONOMIE_MEDIA_API',
  sport: 'SPORT_MEDIA_API',
};

const SECTION_API_ENV_KEY_BY_CATEGORY = {
  culturel: 'CULTUREL_API',
  economie: 'ECONOMIE_API',
  sport: 'SPORT_API',
};

function normalizeCategory(category) {
  const key = String(category || '').trim().toLowerCase();
  return SECTION_API_PATH_BY_CATEGORY[key] ? key : 'culturel';
}

/**
 * Backend mediaLocale (upload + getMedia) pour les sections (culturel, economie, sport) — pas la section politique (/api/media) ni user-media-profile.
 * En local, même origine (/api/media-locale) via proxy (server.dev / server.prod).
 */
export function getSectionMediaApiRoot(category = 'culturel') {
  const normalizedCategory = normalizeCategory(category);
  if (typeof window !== 'undefined') {
    try {
      // Keep Consulter aligned with the active frontend host/port (localhost, 127.0.0.1, LAN IP, etc.).
      return new URL('/api/media-locale', window.location.origin).href.replace(/\/$/, '');
    } catch {
      /* ignore */
    }
  }

  const dedicated = SECTION_MEDIA_ENV_BY_CATEGORY[normalizedCategory];
  if (dedicated) {
    return resolveApiUrl(
      dedicated,
      FALLBACK_MEDIA_LOCALE,
      SECTION_MEDIA_ENV_KEY_BY_CATEGORY[normalizedCategory]
    );
  }

  const generic = process.env.REACT_APP_MEDIA_API || '';
  const looksLikeProfile = generic.includes('user-media-profile');
  const looksLikeGeneraleOnly = generic.includes('/api/media') && !generic.includes('media-locale');
  const looksLikeLocale = generic.includes('media-locale');
  if (generic && looksLikeLocale && !looksLikeProfile && !looksLikeGeneraleOnly) {
    return resolveApiUrl(generic, FALLBACK_MEDIA_LOCALE, 'MEDIA_API');
  }
  return resolveApiUrl(
    '',
    FALLBACK_MEDIA_LOCALE,
    SECTION_MEDIA_ENV_KEY_BY_CATEGORY[normalizedCategory]
  );
}

/** Base messages section (CRUD) pour culturel/économie/sport. */
export function getSectionApiRoot(category = 'culturel') {
  const normalizedCategory = normalizeCategory(category);
  if (typeof window !== 'undefined') {
    try {
      return new URL(SECTION_API_PATH_BY_CATEGORY[normalizedCategory], window.location.origin).href.replace(/\/$/, '');
    } catch {
      /* ignore */
    }
  }
  return resolveApiUrl(
    SECTION_API_ENV_BY_CATEGORY[normalizedCategory],
    'http://localhost:2005/api',
    SECTION_API_ENV_KEY_BY_CATEGORY[normalizedCategory]
  );
}

export function getSectionMediaOrigin(category = 'culturel') {
  try {
    const u = new URL(getSectionMediaApiRoot(category));
    return `${u.protocol}//${u.host}`;
  } catch {
    return 'http://localhost:2008';
  }
}

/** Chemins relatifs /api/uploads-locale/… → URL absolue (même origine en local avec proxy). */
export function absolutizeSectionMediaPath(pathOrUrl, category = 'culturel') {
  if (!pathOrUrl || typeof pathOrUrl !== 'string') return pathOrUrl;
  if (pathOrUrl.startsWith('http://') || pathOrUrl.startsWith('https://')) return pathOrUrl;
  const base = getSectionMediaApiRoot(category);
  try {
    const origin = new URL(base).origin;
    if (pathOrUrl.startsWith('/')) return `${origin}${pathOrUrl}`;
  } catch {
    /* ignore */
  }
  return pathOrUrl;
}
